import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Switch extends Component {
  isLastChild = index => {
    const childCount = React.Children.count(this.props.children)
    return index === childCount - 1
  }

  findCurrentCase = () =>
    React.Children.toArray(this.props.children).find(
      (child, index) => child.props.value === this.props.value || this.isLastChild(index)
    )

  render() {
    return this.findCurrentCase()
  }
}
Switch.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node.isRequired
}

export default Switch
